import { ComponentFactoryResolver, ComponentRef, Injectable, Injector } from '@angular/core';
import { PoprToastComponent } from './popr-toast.component';
import { Popr } from '../popr';
import { PoprViewService } from '../popr-view.service';

/**
 * Container for toast Poprs.
 *
 * @see {@link PoprService}
 */
@Injectable({
  providedIn: 'any'
})
export class PoprToast extends Popr {
  private readonly poprToastComponentRef!: ComponentRef<PoprToastComponent>;
  private poprToastComponent!: PoprToastComponent;

  constructor(
    private injector: Injector,
    private poprView: PoprViewService<PoprToastComponent>,
    private resolver: ComponentFactoryResolver,
  ) {
    super();
    this.poprToastComponentRef = this.createPoprToastComponent();
    this.poprToastComponent = this.poprToastComponentRef?.instance;
    this.poprToastComponent?.onClose$().subscribe(() => {
      this.poprToastComponentRef?.destroy();
      super.close();
    });
  }

  /**
   * @inheritDoc
   */
  close(): void {
    this.poprToastComponent?.close();
  }

  /**
   * @inheritDoc
   */
  open(): void {
    this.poprView.insert(this.poprToastComponentRef);
    this.poprToastComponent.open();
    super.open();
  }

  private createPoprToastComponent(): ComponentRef<PoprToastComponent> {
    const factory = this.resolver.resolveComponentFactory(PoprToastComponent);
    return factory.create(this.injector);
  }
}
